import React from 'react'
import {
  Box,
  Flex,
  Text,
  Link,
  useColorModeValue,
} from '@chakra-ui/react'
import { FaLinkedin, FaGithub } from 'react-icons/fa'
import {FaXTwitter} from 'react-icons/fa6'

const Footer = () => {
  const footerBg = useColorModeValue('black.100', 'black.700') // Light mode/dark mode background color

  return (
    <Box as="footer" bg={footerBg} py={4} width="100%">
      <Flex
        direction={{ base: "column", md: "row" }} // stacked on mobile, inline on desktop
        gap={20}
        wrap="wrap"
        justify="center"
        align="center"
        mb={2}
      >
        <Text fontSize="sm" color="gray.500">
          Copyright &copy; {new Date().getFullYear()} Gemini-CyberSecurity.com - All Rights Reserved.
        </Text>

        {/* Policies */}
        <Flex direction="row" gap={6} wrap="wrap" justify="center">
          <Link href="/terms" color="blue.500" fontSize="sm">
            Terms & Conditions
          </Link>
          <Link href="/privacy" color="blue.500" fontSize="sm">
            Privacy Policy
          </Link>
          <Link href="/cookies" color="blue.500" fontSize="sm">
            Cookie Policy
          </Link>
        </Flex>

        {/* Social Links */}
        <Flex direction="row" gap={4} align="center">
          <Link
            href="https://www.linkedin.com/company/gemini-cyber-security"
            isExternal
            color="gray.400"
            _hover={{ color: 'blue.500' }}
          >
            <FaLinkedin size="20" />
          </Link>
          <Link
            href="https://x.com/#"
            isExternal
            color="gray.400"
            _hover={{ color: 'skyblue' }}
          >
            <FaXTwitter size="20" />
          </Link>
          <Link
            href="https://github.com/#"
            isExternal
            color="gray.400"
            _hover={{ color: 'white' }}
          >
            <FaGithub size="20" />
          </Link>
        </Flex>

        <Text fontSize="sm" color="gray.500">
          Designed by Gemini Cyber Security
        </Text>
      </Flex>
    </Box>
  )
}

export default Footer
